export const FACTOR_ENUMS = {
  PAYMENT_HISTORY: 'PAYMENT_HISTORY',
  CREDIT_USAGE: 'CREDIT_USAGE',
  CREDIT_AGE: 'CREDIT_AGE',
  ACCOUNT_MIX: 'ACCOUNT_MIX',
  CREDIT_INQUIRIES: 'CREDIT_INQUIRIES',
  DEFAULT: 'TODAY',
  POTENTIAL_CREDIT_PROFILE: 'POTENTIAL_CREDIT_PROFILE',
};

export const BUREAU_ENUMS = {
  ALL: 'ALL',
  TRANS_UNION: 'TRANS_UNION',
  EXPERIAN: 'EXPERIAN',
  EQUIFAX: 'EQUIFAX',
};

export const GRADES_FOR_DEBT_PAYOFF_MODULE = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  F: 'F',
};

export const FACTOR_ATTRIBUTE_NAME_MAP = new Map([
  [FACTOR_ENUMS?.PAYMENT_HISTORY, 'paymentHistory'],
  [FACTOR_ENUMS?.ACCOUNT_MIX, 'accountMix'],
  [FACTOR_ENUMS?.CREDIT_AGE, 'creditAge'],
  [FACTOR_ENUMS?.CREDIT_INQUIRIES, 'inquiries'],
  [FACTOR_ENUMS?.CREDIT_USAGE, 'creditUsage'],
]);

export const BUREAU_ATTRIBUTE_NAME_MAP = new Map([
  [BUREAU_ENUMS?.ALL, 'all'],
  [BUREAU_ENUMS?.TRANS_UNION, 'transUnion'],
  [BUREAU_ENUMS?.EQUIFAX, 'equifax'],
  [BUREAU_ENUMS?.EXPERIAN, 'experian'],
]);
